var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 125,
    viewBox: "0 0 248 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5703 65.9197L178.97 108.16",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.69 59.5197L178.97 108.16L243.29 120.96M153.69 59.5197L225.69 3.83966M153.69 59.5197L44.57 65.2797L4.25 22.3997",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 243.29,
    cy: 120.96,
    r: 3.52,
    fill: "white",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.65,
    cy: 107.52,
    r: 3.52,
    fill: "white",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.69,
    cy: 59.5197,
    r: 3.52,
    fill: "white",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.01,
    cy: 3.83963,
    r: 3.52,
    fill: "white",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.2502,
    cy: 64.6397,
    r: 3.52,
    fill: "white",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.92984,
    cy: 22.3996,
    r: 3.52,
    fill: "white",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphLeft);
export default __webpack_public_path__ + "static/media/graph-left.f7689927b2d77ef6487f8f0c7944d4e3.svg";
export { ForwardRef as ReactComponent };